import axios from 'axios';
import {resolve} from 'url';

function uploadOrderNote(userId, orderId, orderNote, stage) {
  let BASE_URL = getCurrentbaseUrl(stage);

  const token = localStorage.getItem("new_openid_token");
  const axiosInstance = axios.create({headers: {'Authorization' : `${token}`, 'Content-Type': 'application/json'}});
  const url = resolve(BASE_URL, `/users/${userId}/orders/${orderId}`);
  const payload = {'updated_order_data': '{"order_note": "'+orderNote+'"}'}

  return axiosInstance.put( url, payload);
}

export function uploadOrderNoteToDev(userId, orderId, orderNote) {
  return uploadOrderNote(userId, orderId, orderNote, 'dev');
}

export function uploadOrderNoteToTest(userId, orderId, orderNote) {
  return uploadOrderNote(userId, orderId, orderNote, 'test');
}

export async function getUserDocumentGraphQL(fileName, stage) {
  const token = localStorage.getItem("new_openid_token");

  return await axios({
    method: "POST",
    url: process.env.VUE_APP_GQLAPI_URL,
    data: {
      query: `
      query downloadFileS3 {
        downloadFile(bucket: "netzportal-orders-${stage}", key: "${fileName}")
      }`
    },
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'application/graphql'        
    }
  })
}

export function triggerSendEmail(orderId, fileName, stage) {
  let BASE_URL = getCurrentbaseUrl(stage);

  const dataUrl = `/templates/${stage}/${fileName}?order_id=${orderId}&generate_pdf=false&send_email=true`;

  const token = localStorage.getItem("new_openid_token");
  const axiosInstance = axios.create({headers: {'Authorization' : `${token}`}, responseType: 'blob'});
  const url = resolve(BASE_URL, dataUrl);

  return axiosInstance.get(url);
}

function getCurrentbaseUrl(stage){
  switch (stage) {
    case 'dev':
      return process.env.VUE_APP_DEV_API_URL
    case 'test':
      return process.env.VUE_APP_TEST_API_URL;
    case 'prod':
      return process.env.VUE_APP_PROD_API_URL;
  }
}
